export default {"src":"/_next/static/media/zoom-out.b2a82dbf.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};